/* tslint:disable */
/* eslint-disable */
/**
 * True one Services API
 * True one service for form Builder
 *
 * The version of the OpenAPI document: 4.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  Machine,
  MachinePart,
  PageResponseMachine,
} from '../models/index';
import {
    MachineFromJSON,
    MachineToJSON,
    MachinePartFromJSON,
    MachinePartToJSON,
    PageResponseMachineFromJSON,
    PageResponseMachineToJSON,
} from '../models/index';

export interface AddPartRequest {
    id: string;
    machinePart: MachinePart;
}

export interface CreateMachineRequest {
    machine: Machine;
}

export interface DeleteMachineRequest {
    id: string;
}

export interface DeleteMachineLegacyRequest {
    id: string;
}

export interface GetAll2Request {
    pageNumber?: number;
    perPage?: number;
    sort?: string;
}

export interface GetAllMachinePartsLegacyRequest {
    id: string;
}

export interface GetMachineRequest {
    id: string;
}

export interface GetMachineLegacyRequest {
    id: string;
}

export interface RemovePartRequest {
    id: string;
    partId: string;
}

export interface SaveMachineLegacyRequest {
    machine: Machine;
}

export interface UpdateMachineRequest {
    id: string;
    machine: Machine;
}

/**
 * 
 */
export class MachineControllerApi extends runtime.BaseAPI {

    /**
     */
    async addPartRaw(requestParameters: AddPartRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Machine>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling addPart().'
            );
        }

        if (requestParameters['machinePart'] == null) {
            throw new runtime.RequiredError(
                'machinePart',
                'Required parameter "machinePart" was null or undefined when calling addPart().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/machines/{id}/parts`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MachinePartToJSON(requestParameters['machinePart']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MachineFromJSON(jsonValue));
    }

    /**
     */
    async addPart(requestParameters: AddPartRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Machine> {
        const response = await this.addPartRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async createMachineRaw(requestParameters: CreateMachineRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Machine>> {
        if (requestParameters['machine'] == null) {
            throw new runtime.RequiredError(
                'machine',
                'Required parameter "machine" was null or undefined when calling createMachine().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/machines`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MachineToJSON(requestParameters['machine']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MachineFromJSON(jsonValue));
    }

    /**
     */
    async createMachine(requestParameters: CreateMachineRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Machine> {
        const response = await this.createMachineRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async deleteMachineRaw(requestParameters: DeleteMachineRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteMachine().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/machines/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteMachine(requestParameters: DeleteMachineRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteMachineRaw(requestParameters, initOverrides);
    }

    /**
     */
    async deleteMachineLegacyRaw(requestParameters: DeleteMachineLegacyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteMachineLegacy().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/machine/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteMachineLegacy(requestParameters: DeleteMachineLegacyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteMachineLegacyRaw(requestParameters, initOverrides);
    }

    /**
     */
    async getAll2Raw(requestParameters: GetAll2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PageResponseMachine>> {
        const queryParameters: any = {};

        if (requestParameters['pageNumber'] != null) {
            queryParameters['pageNumber'] = requestParameters['pageNumber'];
        }

        if (requestParameters['perPage'] != null) {
            queryParameters['perPage'] = requestParameters['perPage'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/machine`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PageResponseMachineFromJSON(jsonValue));
    }

    /**
     */
    async getAll2(requestParameters: GetAll2Request = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PageResponseMachine> {
        const response = await this.getAll2Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getAllMachinePartsLegacyRaw(requestParameters: GetAllMachinePartsLegacyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<MachinePart>>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getAllMachinePartsLegacy().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/machine/{id}/parts`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(MachinePartFromJSON));
    }

    /**
     */
    async getAllMachinePartsLegacy(requestParameters: GetAllMachinePartsLegacyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<MachinePart>> {
        const response = await this.getAllMachinePartsLegacyRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getAllMachinesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Machine>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/machines`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(MachineFromJSON));
    }

    /**
     */
    async getAllMachines(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Machine>> {
        const response = await this.getAllMachinesRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getAllMachinesLegacyRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Machine>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/machine/all`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(MachineFromJSON));
    }

    /**
     */
    async getAllMachinesLegacy(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Machine>> {
        const response = await this.getAllMachinesLegacyRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getMachineRaw(requestParameters: GetMachineRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Machine>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getMachine().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/machines/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MachineFromJSON(jsonValue));
    }

    /**
     */
    async getMachine(requestParameters: GetMachineRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Machine> {
        const response = await this.getMachineRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getMachineLegacyRaw(requestParameters: GetMachineLegacyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Machine>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getMachineLegacy().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/machine/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MachineFromJSON(jsonValue));
    }

    /**
     */
    async getMachineLegacy(requestParameters: GetMachineLegacyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Machine> {
        const response = await this.getMachineLegacyRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async removePartRaw(requestParameters: RemovePartRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Machine>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling removePart().'
            );
        }

        if (requestParameters['partId'] == null) {
            throw new runtime.RequiredError(
                'partId',
                'Required parameter "partId" was null or undefined when calling removePart().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/machines/{id}/parts/{partId}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"partId"}}`, encodeURIComponent(String(requestParameters['partId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MachineFromJSON(jsonValue));
    }

    /**
     */
    async removePart(requestParameters: RemovePartRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Machine> {
        const response = await this.removePartRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async saveMachineLegacyRaw(requestParameters: SaveMachineLegacyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Machine>> {
        if (requestParameters['machine'] == null) {
            throw new runtime.RequiredError(
                'machine',
                'Required parameter "machine" was null or undefined when calling saveMachineLegacy().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/machine`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MachineToJSON(requestParameters['machine']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MachineFromJSON(jsonValue));
    }

    /**
     */
    async saveMachineLegacy(requestParameters: SaveMachineLegacyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Machine> {
        const response = await this.saveMachineLegacyRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async updateMachineRaw(requestParameters: UpdateMachineRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Machine>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateMachine().'
            );
        }

        if (requestParameters['machine'] == null) {
            throw new runtime.RequiredError(
                'machine',
                'Required parameter "machine" was null or undefined when calling updateMachine().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/machines/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: MachineToJSON(requestParameters['machine']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MachineFromJSON(jsonValue));
    }

    /**
     */
    async updateMachine(requestParameters: UpdateMachineRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Machine> {
        const response = await this.updateMachineRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
